<template>
  <div id="editItemWrapper">
    <div class="columns">
      <div class="column">
        <div class="notification" v-show="loading">Laden...</div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-one-fifth">
        <p><router-link :to="{ name: 'items' }"><span class="icon"><i class="fas fa-chevron-left"></i></span> Terug</router-link></p>
      </div>

      <div class="column is-four-fifths-table is-half-desktop">
        <div class="card">
          <http-messages :success="success" :errors="errors"></http-messages>

          <header class="card-header">
            <p class="card-header-title">Onderwerp bewerken</p>
          </header>

          <div class="card-content">
            <form>
              <div class="field">
                <label class="label" for="item-name">Naam</label>
                <div class="control">
                  <input name="item-name" class="input" id="itemName" placeholder="Naam" v-model="item.name">
                </div>
                <p v-for="message in errors.name" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <label for="parentItem" class="label">Onderdeel van</label>
                <div class="select">
                  <select name="item-id" v-model="item.item_id">
                    <option v-for="i in items" :value="i.id">{{ i.name }}</option>
                  </select>
                </div>
                <p v-for="message in errors.item_id" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <label class="label" for="item-question">Vraag bij de intake</label>
                <div class="control">
                  <input name="item-question" class="input" id="itemName" placeholder="Vraag bij intake" v-model="item.question">
                </div>
              </div>

              <div class="field">
                <label class="label" for="item-description">Beschrijving</label>
                <div class="control">
                  <textarea class="textarea" id="itemDescription" name="item-description" placeholder="Beschrijving van het thema" rows="10" v-model="item.description"></textarea>
                </div>
                <p v-for="message in errors.description" class="help is-danger">{{ message }}</p>
              </div>

              <hr>

              <label class="label">Producten bij dit onderwerp</label>

              <div v-for="(product, index) in item.products" class="box">
                <button type="button" class="delete is-pulled-right" @click="removeProduct(index)"></button>
                <article class="media">
                  <div class="media-left">
                    <figure class="image is-64x64">
                      <img v-if="product.images" :src="product.images[0]" :alt="product.name">
                    </figure>
                  </div>
                  <div class="media-content">
                    <div class="content">
                      <p><strong>{{ product.name }}</strong></p>
                      <div class="content" v-html="product.description.length > 250 ? `${product.description.substr(0, 250)}...` : product.description"></div>
                    </div>
                  </div>
                </article>
              </div>

              <button class="button" type="button" @click="selectProduct">Product toevoegen</button>

              <hr>

              <label class="label">Kennis bij dit onderwerp</label>

              <div v-for="(knowledgeItem, index) in item.knowledge" class="box">
                <button type="button" class="delete is-pulled-right" @click="removeKnowledgeItem(index)"></button>
                <article class="media">
                  <div class="media-left">
                    <figure class="image is-64x64">
                      <img v-if="knowledgeItem.attachments" :src="knowledgeItem.attachments[0].file" :alt="knowledgeItem.title">
                    </figure>
                  </div>
                  <div class="media-content">
                    <div class="content">
                      <p><strong>{{ knowledgeItem.title }}</strong></p>
                      <div class="content" v-html="knowledgeItem.description.length > 250 ? `${knowledgeItem.description.substr(0, 250)}...` : knowledgeItem.description"></div>
                    </div>
                  </div>
                </article>
              </div>

              <button class="button" type="button" @click="selectKnowledgeItem">Kennis toevoegen</button>

            </form>
          </div>

          <footer class="card-footer">
            <a
              class="button is-text card-footer-item"
              @click="save"
              :class="{ 'is-loading': loading }">
              Opslaan
            </a>
          </footer>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-four-fifths-tablet is-half-desktop is-offset-one-fifth">
        <button type="button" class="button is-danger is-fullwidth" @click="delItem">Item verwijderen</button>
      </div>
    </div>

    <!-- Product select modal -->
    <div class="modal" :class="{ 'is-active': showProducts }">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">

          <div class="field">
            <div class="control">
              <input type="text" v-model="productQuery" placeholder="Zoeken">
            </div>
          </div>

          <div
            class="box"
            v-if="!product.hide"
            v-for="(product, index) in filteredProducts"
            @click="addProduct(product.id, index)">
            <article class="media">
              <div class="media-left" v-if="hasImage(index)">
                <figure class="image is-64x64">
                  <img :src="product.images[0].file" alt="Afbeelding niet gevonden">
                </figure>
              </div>
              <div class="media-content">
                <div class="content">
                  <p>
                    <strong>{{ product.name }}</strong> <small>{{ product.supplier.name }}</small>
                  </p>
                </div>
              </div>
            </article>
          </div>

        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="closeModal('products')"></button>
    </div>

    <!-- Knowledge select modal -->
    <div class="modal" :class="{ 'is-active': showKnowledgeItems }">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          <div class="field">
            <div class="control">
              <input type="text" v-model="knowledgeQuery" placeholder="Zoeken">
            </div>
          </div>

          <div
            class="box"
            v-if="!knowledgeItem.hide"
            v-for="(knowledgeItem, index) in filteredKnowledge"
            @click="addKnowledgeItem(knowledgeItem.id, index)">
            <article class="media">
              <div class="media-content">
                <div class="content">
                  <p>
                    <strong>{{ knowledgeItem.title }}</strong>
                  </p>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
      
      <button class="modal-close is-large" aria-label="close" @click="closeModal('knowledge')"></button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { bus } from '@/main'
  import _ from 'lodash'
  import Documents from '@/components/documents/Documents'
  import HttpMessages from '@/components/http/HttpMessages'

  export default {
    components: {
      HttpMessages
    },
    data () {
      return {
        item: {
          products: [],
          documents: []
        },
        items: [],
        products: [],
        knowledge: [],
        loading: false,
        showProducts: false,
        showKnowledgeItems: false,
        errors: {},
        success: false,
        productQuery: null,
        knowledgeQuery: null
      }
    },
    computed: {
      filteredProducts () {
        if (!this.productQuery) {
          return this.products
        }

        return this.products.filter((product) => {
          return product.name.toLowerCase().includes(this.productQuery.toLowerCase())
        })
      },
      filteredKnowledge () {
        if (!this.knowledgeQuery) {
          return this.knowledge
        }

        return this.knowledge.filter((item) => {
          return item.title.toLowerCase().includes(this.knowledgeQuery.toLowerCase())
        })
      }
    },
    created () {
      this.fetchItems()
      this.fetchProducts()
      this.fetchKnowledge()
      if (this.$route.params.id) this.fetchItem(this.$route.params.id)

      let self = this

      bus.$on('documentStored', function (payload) {
        self.item.documents.unshift(payload)
      })

      bus.$on('documentEdited', function (payload) {
        let index = _.findIndex(self.items.documents, { id: payload.id })
        self.item.documents.splice(index, 1, payload)
      })
    },
    methods: {
      hasImage (idx) {
        if (!this.products[idx].images) return false
        return typeof this.products[idx].images[0] !== 'undefined'
      },
      isEmpty (obj) {
        for(var key in obj) {
          if (obj.hasOwnProperty(key)) {
            return false
          }
        }

        return true
      },
      fetchItem (id) {
        axios
          .get('/items/' + id)
          .then(response => {
            this.item = response.data;
          }).catch(
            (res) => {
              this.errors = error.response.data.errors
            }
          )
      },
      save () {
        this.loading = true
        this.errors = {}
        this.success = false

        if (this.item.id) {
          axios
            .put(`/items/${this.item.id}`, this.item)
            .then(response => {
              this.loading = false
              this.success = true
            })
            .catch((error) => {
              this.loading = false
              this.errors = error.response.data.errors
            })
        } else {
          axios.post(
            '/items', this.item
          ).then(
            (res) => {
              this.loading = false
              this.success = true
              this.item = res.data
              this.$router.push({
                name: 'item-edit', params: {
                  id: res.data.id
                }
              })
            }
          ).catch(
            (error) => {
              this.loading = false
              this.errors = error.response.data.errors
          })
        }
      },
      delItem () {
        axios
          .delete('/items/' + this.item.id)
          .then(response => {
            this.$router.push({name: 'items'})
          })
          .catch((error) => {
            console.log(error)
          })
      },
      fetchItems () {
        this.loading = true
        axios
          .get('/items/flat/all')
          .then(response => {
            this.loading = false;
            this.items = response.data;
          }).catch(error => {
            this.loading = false;
            this.errors = error.response.data.message || error.message;
          })
      },
      fetchProducts () {
        this.loading = true
        axios
          .get('/products')
          .then(response => {
            this.loading = false
            this.products = response.data

            for (let product of this.products) {
              if (this.item.products.find(x => x.id === product.id)) product.hide = true
            }
          }).catch(error => {
            this.loading = false
            this.errors = error.response.data.message || error.message
          });
      },
      fetchKnowledge () {
        this.loading = true
        axios
          .get('/knowledge')
          .then(response => {
            this.loading = false
            this.knowledge = response.data

            for (let knowledgeItem of this.knowledge) {
              if (this.item.knowledge.find(x => x.id === knowledgeItem.id)) knowledgeItem.hide = true
            }
          }).catch(error => {
            this.loading = false
            this.errors = error.response.data.message || error.message
          });
      },
      selectProduct () {
        this.showProducts = true
      },
      selectKnowledgeItem () {
        this.showKnowledgeItems = true
      },
      closeModal (modal) {
        if (modal === 'products') {
          this.showProducts = false
        }

        if (modal === 'knowledge') {
          this.showKnowledgeItems = false
        }
      },
      addProduct (id, idx) {
        this.loading = true
        axios
          .get('/products/' + id)
          .then(response => {
            this.loading = false
            this.item.products.unshift(response.data)
            this.products[idx].hide = true
          })
          .catch(error => {
            this.loading = false
            console.log(error)
          })
      },
      removeProduct (index) {
        this.item.products.splice(index, 1)
      },
      addKnowledgeItem (id, idx) {
        this.loading = true
        axios
          .get('/knowledge/' + id)
          .then(response => {
            this.loading = false
            this.item.knowledge.unshift(response.data)
            this.knowledge[idx].hide = true
          })
          .catch(error => {
            this.loading = false
            console.log(error)
          })
      },
      removeKnowledgeItem (index) {
        this.item.knowledge.splice(index, 1)
      },
      notSelected (id) {
        return true
      }
    }
  }
</script>

<style scoped>
  .button.is-text {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/ItemEdit.vue